import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRREP_RPT_DET;

export default {
  read(payload) {
    return baseApi.post(resource, payload);
  },
};
